<!--答疑库详情-->
<!--wj-->
<template>
    <div class="qbDetail">
        <detail-title></detail-title>
        <el-row class="qbDetail-row" >
            <el-col :span="2" class="Question-wen"><img :src="wenImg"></el-col>
            <el-col :span="22" class="wen-name" v-html="list.trsqbText">{{list.trsqbText}}</el-col>
              <el-col :span="2" class="Question-wen"><img :src="daImg"></el-col>
            <el-col :span="22" class="da-name" v-html="list.trsqbAnswer">{{list.trsqbAnswer}}</el-col>
        </el-row>
        <share-wechat></share-wechat>
    </div>
</template>
<script>
import Axios from "axios";
import { eventBus } from '@/assets/js/eventBus';
import ShareWechat from "@/components/ShareWechat";
import DetailTitle from '@/components/DetailTitle';
export default {
    data(){
        return{
            list:[],
            wenImg:require('@/assets/image/wenImg.svg'),
            daImg:require('@/assets/image/daImg.svg'),
        };
    },
    mounted(){
        const that = this;
        var id;
        var locations = location.href;
        if (locations.indexOf("?") != -1) {    //判断是否有参数
          if(locations.indexOf("from") != -1){
                var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
                var strs = str.split("?");
                id = strs[2];
          }else{
            var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
            var strs = str.split("?");
            id = strs[1];   //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
          }
        }
        var search='';
        Axios.get(that.$store.state.APIURLS+"Trsqb/findByIdEs?"+id+"&search="+search).then(function(res) {
            if(res.data.code == 200){
                that.list = res.data.data;
                var shareList = {
                    title: res.data.data.trsqbText,
                    content: res.data.data.trsqbAnswer,
                };
                eventBus.$emit("shareList", shareList);
            }
        });
    },
    components:{
        DetailTitle,
        ShareWechat
    },
};
</script>

